
import type { AllowedTransition } from '@/entities/ticket';

const RARE_TRANSITION_TARGETS = new Set(['on_approval', 'handed_to_devs']);

type Placed = Pick<AllowedTransition, 'to' | 'placement'>;

export function isBarCandidate(t: Placed): boolean {
  if (t.placement) return t.placement !== 'menu';
  return !RARE_TRANSITION_TARGETS.has(t.to);
}

const RANK: Record<string, number> = { primary: 0, bar: 1 };

export function orderByPlacement<T extends Placed>(list: T[]): T[] {
  const rank = (t: Placed) => (t.placement ? (RANK[t.placement] ?? 2) : 2);
  return [...list].sort((a, b) => rank(a) - rank(b));
}
